import prjnoteActionTypes from "./prjnotes.types";

export const setPrjNotes = (prjnotes) => ({
  type: prjnoteActionTypes.SET_PRJNOTES,
  payload: prjnotes,
});
